import { createRoot } from "react-dom/client";
// Font self-hostati (@fontsource) al posto di fonts.googleapis.com — nessuna
// richiesta a Google prima del consenso.
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
